export const backToCartEventInfo = url =>
  JSON.stringify({
    eventAction: "checkout:back to cart",
    eventName: "checkout:back to cart",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to cart",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:header:navigation",
    internalLinkURL:
      (url?.indexOf("http") === -1 ? window.location.origin : "") + url,
    clickInternalLinks: "true",
  })

export const callSupportAnalyticsData = (contactnumber = "") =>
  JSON.stringify({
    eventAction: "checkout:order summary:call support phone number",
    eventName: "checkout:order summary:call support phone number",
    eventType: "help support",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: contactnumber,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:order summary",
    internalLinkURL: `tel:${contactnumber}`,
    clickInternalLinks: "true",
  })

export const verifyAddressAnalyticsData = action =>
  JSON.stringify({
    eventAction: `checkout:shipping verify address:${action}`,
    eventName: `checkout:shipping verify address:${action}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: action === "use original" ? "success" : "n/a",
    internalLinkName: action,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping verify address",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })

export const saveAddresstoggleAnalyticsData = type => {
  const toggleText = type ? "enable" : "disable"
  return JSON.stringify({
    eventAction: `checkout:shipping:toggle ${toggleText}`,
    eventName: `checkout:shipping:toggle ${toggleText}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `please save this address to my address book:${toggleText}`,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}

export const continueToPaymentAnalyticsData = type => {
  return {
    eventAction: `checkout:delivery options:next`,
    eventName: `checkout:delivery options:next`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "continue to payment",
    internalLinkPosition: "checkout",
    internalLinkType: `checkout:delivery option:${type}`,
    internalLinkZoneName: "checkout:delivery options",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
}
